define('views/content/customer_licenses',['require','views/base/list_page_view','views/components/customer_product/customer_products','collections/customer_products','models/customer','models/reseller','views/components/reseller_contact_card/reseller_contact_card','views/components/purchase_information/purchase_information','text!templates/content/customer_licenses.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var CustomerProductsView = require('views/components/customer_product/customer_products');
    var CustomerProductsCollection = require('collections/customer_products');

    var CustomerModel = require('models/customer');
    var ResellerModel = require('models/reseller');
    var ResellerContactCardView = require('views/components/reseller_contact_card/reseller_contact_card');

    var PurchaseInformationView = require('views/components/purchase_information/purchase_information');

    var temp = require("text!templates/content/customer_licenses.html");
    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'customer-licenses-page',
        titleKey: 'licenses',

        setCollection: function () {
            this.collection = new CustomerProductsCollection();
        },

        regions: function() {
            return {
                ListContainer: ".main-list-container",
                ResellerCardContainer: ".reseller-card-container",
                PurchaseInformationContainer: ".purchase-information-container"
            };
        },

        onRender: function() {
            var _this = this;

            this.ListContainer.show(new CustomerProductsView({
                collection: this.collection
            }));

            this.PurchaseInformationContainer.show(new PurchaseInformationView());

            var customer = new CustomerModel({
                id: App.user.get('customer')
            });

            customer.fetch({
                success: function () {
                    _this.ResellerCardContainer.show(new ResellerContactCardView({
                        model: new ResellerModel(customer.get('reseller_object'))
                    }));
                }
            });
        }

    });
});
